import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postUserList: (params: UserListReqDto): Promise<UserListResDto> =>
    request({
      url: endpoints.user.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postUserAdd: (params: UserSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.user.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postUserUpdate: (params: UserSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.user.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postResetPassword: (params: UserSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.user.resetpassword,
      method: 'post',
      data: paramsToFormData(params),
    }),          
};
